import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {first} from 'rxjs/operators';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {BlogFilter} from '../../shared/entities/blog-filter';
import {ApiBackendService} from '../../shared/services/api-backend.service';
import {GetOverviewResponse} from '../../shared/entities/get-overview-response';
import {Blog} from '../../shared/entities/blog';
import {DateUtils} from '../../shared/utils/date.utils';
import {ActivatedRoute, Router} from '@angular/router';
import {ShareMetaSeoService} from '../../shared/services/share-meta-seo.service';
import {NavbarService} from "../../shared/services/navbar.service";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'gryf-blogs',
  templateUrl: './blogs.component.html',
})
export class BlogsComponent implements OnInit, OnDestroy {

  numberOfBlogs: number;
  buttons: any;
  startEnd: boolean;
  actualPageIndex: number;
  previousPageIndex: number;
  blogGetOverviewResponse: GetOverviewResponse<Blog> = null;

  filter: BlogFilter = {
    statusId: null,
    genreId: null,
    limit: 9,
    offset: 0,
  };

  constructor(
    private share: ShareMetaSeoService,
    private navbarService: NavbarService,
    private router: Router,
    private route: ActivatedRoute,
    private apiBackendService: ApiBackendService,
    private domSanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  getBlogs(): void {
    this.route.data.subscribe(data => {
      this.share.updateSeoData(data.seo);
    });

    this.apiBackendService.getBlogs(this.filter.statusId, this.filter.genreId, this.filter.limit, this.filter.offset)
      .pipe(first()).subscribe(value => {
      if (value) {
        this.blogGetOverviewResponse = value;
        this.numberOfBlogs = this.blogGetOverviewResponse.recordsCount;
        if (this.numberOfBlogs) {
          this.paginationButtons();
        }
        this.blogGetOverviewResponse.list.forEach(blog => {
          if (blog && blog.mainPhotoId) {
            this.apiBackendService.getBase64BlogPhoto(blog.mainPhotoId)
              .pipe(first()).subscribe(fileObject => {
              if (fileObject && fileObject.fileContent) {
                const base64Content = 'data:image/jpeg;charset=utf-8;base64, ' + fileObject.fileContent;
                blog.safeBase64Content = this.domSanitizer.bypassSecurityTrustUrl(base64Content);
              } else {
                blog.safeBase64Content = null;
              }
            }, error => {
              console.error(error);
            });
          }
        });
      } else {
        this.blogGetOverviewResponse = null;
      }
    }, error => {
      console.error(error);
    });
  }

  getFormattedDate(instantDate: string) {
    return DateUtils.formatDateSk(instantDate);
  }

  showBlogDetailbyUrl(blogurl: string): void {
    this.router.navigate(['/blog', blogurl]);
  }

  paginationButtons(): void {
    let number = Math.floor(this.numberOfBlogs / this.filter.limit);
    if (this.numberOfBlogs % this.filter.limit !== 0) {
      number++;
    }
    this.buttons = Array(number - 1).fill(0).map((x, i) => i);
    this.startEnd = this.buttons.length > 0;
  }

  getBlogsForCurrentPage(pageIndex) {
    this.previousPageIndex = this.actualPageIndex;
    this.actualPageIndex = pageIndex;
    this.filter.offset = this.filter.limit * this.actualPageIndex;
    this.getBlogs();

    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }

  ngOnInit(): void {
    this.share.createLinkForCanonicalURL();
    this.navbarService.navbarInit();

    this.route.params.subscribe(params => {
      const page = +params['page'] || 0;
      this.actualPageIndex = page - 1;
      this.getBlogsForCurrentPage(page);
    });
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('navbar').classList.remove('navbar-light');
      document.getElementById('logo2').style.display = 'none';
      document.getElementById('logo1').style.display = 'block';
      document.getElementById('about').classList.remove('text-dark');
      document.getElementById('navbarProducts').classList.remove('text-dark');
      document.getElementById('navbarServices').classList.remove('text-dark');
      document.getElementById('navbarContacts').classList.remove('text-dark');
      document.getElementById('ponuka').classList.remove('text-dark');
      document.getElementById('blog').classList.remove('text-dark');
    }
  }
}
